<div class="knowledge-main content-web-section">
    <div class="col-lg-12 row" *ngIf="showTabs">
        <div class="col-lg-3 tabs-section">
          <div  *ngFor="let item of tabsList;let i=index">
            <div class="left-buttons text-center cursor-pointer" (click)="setActive(i,item.displayName)"  [ngClass]="{'active-tab-button':i===activeTabId}">
               <a  class="tab-btn-text"  >{{item.displayName}}</a>
            </div >
          </div>

        </div>
        <div class="col-lg-9">
            <div class="knowledge-heading">{{tabsList[activeTabId].displayHeading}} </div>
            <div *ngIf="!showFull">
            <div class="knowledge-topic cursor-pointer" *ngFor="let item of tabsList[activeTabId].topics.slice(0,3);let i=index">
               <span (click)="setActiveSubTab(i)"> {{item.question}} </span>

            </div>
            <div class="knowledge-topic2 cursor-pointer" *ngIf=" tabsList[activeTabId].topics.length>2" (click)="showFull=true">View all Articles</div>
        </div>
        <div *ngIf="showFull">
            <div class="knowledge-topic cursor-pointer" *ngFor="let item of tabsList[activeTabId].topics;let i=index">
                <span (click)="setActiveSubTab(i)"> {{item.question}} </span>

            </div>
            <div class="knowledge-topic2 cursor-pointer" *ngIf=" tabsList[activeTabId].topics.length>2" (click)="showFull=false">Show less</div>
        </div>
      </div>
      </div>
      <div class="col-lg-12 row" *ngIf="!showTabs">
        <div class="col-lg-3 tabs-section">
            <div class="article-heading">Articles in this section</div>
          <div  *ngFor="let item of tabsList[activeTabId].topics;let i=index">
            <div class="question-tabs cursor-pointer" (click)="setActiveTopic(i)"  [ngClass]="{'active-tab-button2':i===activeTopicId}">
               <a  class="tab-btn-text2"  >{{item.question}}</a>
            </div >
          </div>
        </div>
        <div class="col-lg-9 answer-section">

            <div class="article-heading2">
              {{tabsList[activeTabId].topics[activeTopicId].question}}
              <i class="fa fa-times-circle close-icon cursor-pointer" (click)="goBack()" aria-hidden="true"></i>
            </div>
             <hr>
            <div class="sub-header-2"><span class="update-text">2 Months ago. Updated</span>
                <span class="share-on">
                    Share article to
                    <a href="https://www.facebook.com/sharer/sharer.php?u={{pageUrl}}" target="_blank">
                      <i class="fa fa-facebook-square social-icon" ></i>
                    </a> &nbsp;
                    <a href="https://twitter.com/share?url={{pageUrl}}" target="_blank">
                        <i class="fa fa-twitter-square social-icon" ></i>
                    </a>&nbsp;
                    <a href="https://www.linkedin.com/shareArticle?url={{pageUrl}}" target="_blank">
                        <i class="fa fa-linkedin-square social-icon" ></i>
                    </a>
                </span>
            </div>
            <div class="answwer-content">
                <div *ngFor="let item of tabsList[activeTabId].topics[activeTopicId].answer">
                    <div class="text-answer-section" *ngIf="item.type==='text'">{{item.text}} </div>
                    <div class="text-answer-section" *ngIf="item.type==='list'">
                      <span class="li-heading">{{item.heading}} </span><br>
                      <span class="li-content">{{item.content}} </span>
                    </div>
                    <div class="img-answer-section" *ngIf="item.type==='img'"><img [src]="item.img" width="100%"> </div>
                </div>
             </div>
      </div>
      </div>
      <hr>
      <div class="col-lg-12 row " >
        <div class="col-lg-3 " ></div>
        <div class="col-lg-9 " >
            <div class="knowledge-footer">
                Can't find what you're looking for?
                <br>
                <button type="button" class="submit-button cursor-pointer" (click)="openPopUp()">Submit a Request</button>
            </div>
        </div>
      </div>
</div>



<div class="knowledge-main knowledge-main-mobile content-mobile-section">
  <div class="col-12 row p-0 m-0" *ngIf="showTabs">
      <div class="col-12 tabs-section">
        <select  class="select-data" [(ngModel)]="activeTabId"  >
          <option *ngFor="let item of tabsList;let i=index" [value]="i">{{item.displayName}}</option>
        </select>

      </div>
      <div class="col-lg-9">
          <div class="knowledge-heading">{{tabsList[activeTabId].displayHeading}} </div>
          <div *ngIf="!showFull">
          <div class="knowledge-topic cursor-pointer" *ngFor="let item of tabsList[activeTabId].topics.slice(0,3);let i=index">
             <span (click)="setActiveSubTab(i)"> {{item.question}} </span>

          </div>
          <div class="knowledge-topic2 cursor-pointer" *ngIf=" tabsList[activeTabId].topics.length>2" (click)="showFull=true">View all Articles</div>
      </div>
      <div *ngIf="showFull">
          <div class="knowledge-topic cursor-pointer" *ngFor="let item of tabsList[activeTabId].topics;let i=index">
              <span (click)="setActiveSubTab(i)"> {{item.question}} </span>

          </div>
          <div class="knowledge-topic2 cursor-pointer" *ngIf=" tabsList[activeTabId].topics.length>2" (click)="showFull=false">Show less</div>
      </div>
    </div>

    </div>
    <button type="button" class="floating-button content-mobile-section" (click)="investOnline()" >Invest Online</button>


    <div class="col-lg-12 m-0 p-0 row" *ngIf="!showTabs">
      <div class="col-12 answer-section">

          <div class="article-heading2">
            {{tabsList[activeTabId].topics[activeTopicId].question}}
            <i class="fa fa-times-circle close-icon cursor-pointer" (click)="goBack()" aria-hidden="true"></i>
          </div>
           <hr>
          <div class="sub-header-2 m-0 p-0 col-12 row">
            <div class="update-text col-6">2 Months ago. Updated</div>
              <div class="share-on col-6">
                  <a href="https://www.facebook.com/sharer/sharer.php?u={{pageUrl}}" target="_blank">
                   <img src="assets/icons/facebook-k.png" class="img-share">
                  </a> &nbsp;
                  <a href="https://twitter.com/share?url={{pageUrl}}" target="_blank">
                    <img src="assets/icons/skype-k.png" class="img-share">
                  </a>&nbsp;
                  <a href="https://www.linkedin.com/shareArticle?url={{pageUrl}}" target="_blank">
                    <img src="assets/icons/linkedin-k.png" class="img-share">
                  </a>
                </div>
          </div>
          <div class="answwer-content">
              <div *ngFor="let item of tabsList[activeTabId].topics[activeTopicId].answer">
                  <div class="text-answer-section" *ngIf="item.type==='text'">{{item.text}} </div>
                  <div class="text-answer-section" *ngIf="item.type==='list'">
                    <span class="li-heading">{{item.heading}} </span><br>
                    <span class="li-content">{{item.content}} </span>
                  </div>
                  <div class="img-answer-section" *ngIf="item.type==='img'"><img [src]="item.img" width="100%"> </div>
              </div>
           </div>
    </div>
    </div>
    <hr>
    <div class="col-lg-12 row p-0 m-0 " >
        <div class="col-lg-12 " >
          <div class="knowledge-footer">
              Can't find what you're looking for?
              <br>
              <button type="button" class="submit-button cursor-pointer" (click)="mobileNav('write-to-us')">Submit a Request</button>
          </div>
      </div>
    </div>
</div>

